module.exports = __webpack_public_path__ + "img/khq.109102dc.png";